import { Question } from "../types";
import { EmqPartStepStatus } from "../components/EmqPartStepper/EmqPartStepper";

/** Build per-part stepper statuses from sibling EMQ questions and selection state. */
export function buildEmqPartStatuses(params: {
  siblings: Question[];
  currentPartOrder: number;
  selectedAnswers: { [questionId: number]: number | undefined };
}): EmqPartStepStatus[] {
  const { siblings, currentPartOrder, selectedAnswers } = params;
  const sorted = [...siblings].sort(
    (a, b) => (a.emqPart?.partOrder ?? 0) - (b.emqPart?.partOrder ?? 0),
  );

  return sorted.map((sibling) => {
    const order = sibling.emqPart?.partOrder ?? 0;
    const hasAnswer =
      selectedAnswers[sibling.id] !== undefined ||
      sibling.answerOptions?.some((ao) => ao.selected);
    const isCurrent = order === currentPartOrder;

    if (sibling.skipped) {
      return "skipped";
    }
    if (hasAnswer) {
      return isCurrent ? "current" : "answered";
    }
    if (isCurrent) {
      return "current";
    }
    if (order < currentPartOrder) {
      return "skipped";
    }
    return "pending";
  });
}
